// order.js
// Order related reducers

/****************************************************************
 * Imports
 ****************************************************************/
import * as ProductAction from '../actions/product';
import * as ClientAction from '../actions/client';
import * as Action from '../actions/order';
import dotProp from 'dot-prop-immutable';

/****************************************************************
 * Initial State
 ****************************************************************/
const orderState = {
  current: {
    byClient: {},
    dateClosed: null,
  },
  archive: [],
}

/****************************************************************
 * Action Processors
 ****************************************************************/

// Processes CLIENT_REMOVE
function removeClient (state, action) {
  return dotProp.delete(state, `current.byClient.${action.clientId}`);
}

// Processes PRODUCT_REMOVE
function removeProduct (state, action) {
  var clientId;
  for (clientId in state.current.byClient) {
    state = dotProp.delete(state, `current.byClient.${clientId}.${action.productId}`);  
  }
  for (var i = 0; i < state.archive.length; i++) {
    for (clientId in state.archive[i].byClient) {
      state = dotProp.delete(state, `archive.${i}.byClient.${clientId}.${action.productId}`);  
    }
  }
  return state;
}

// Processes UNIT_REMOVE
function removeUnit (state, action) {
  var clientId, product;
  for (clientId in state.current.byClient) {
    product = state.current.byClient[action.productId];
    if (product && product.unitId === action.unitId)
      state = dotProp.delete(state, `current.byClient.${clientId}.${action.productId}`);  
  }
  for (var i = 0; i < state.archive.length; i++) {
    for (clientId in state.archive[i].byClient) {
      product = state.archive[i].byClient[action.productId];
      if (product && product.unitId === action.unitId)
        state = dotProp.delete(state, `archive.${i}.byClient.${clientId}.${action.productId}`);  
    }
  }
  return state;
}

// Processes ORDER_SET_PRODUCT
function setOrderProduct (state, action) {
  if (action.quantity < 0)
    return state;

  var client = state.current.byClient[action.clientId];
  if (!client) {
    client = {};
    state = dotProp.set(state, `current.byClient.${action.clientId}`, client);
  }

  var product = {
    unitId: action.unitId,
    quantity: action.quantity,
    customPrice: action.customPrice,
  };
  
  if (action.quantity === 0)
    state = dotProp.delete(state, `current.byClient.${action.clientId}.${action.productId}`);
  else
    state = dotProp.set(state, `current.byClient.${action.clientId}.${action.productId}`, product);

  if (Object.keys(state.current.byClient[action.clientId]).length === 0)
    state = dotProp.delete(state, `current.byClient.${action.clientId}`);

  return state;
}

// Processes ORDER_SET_ADJUSTMENT
function setOrderAdjustment (state, action) {
  var client = state.current.byClient[action.clientId];
  if (!client) {
    client = {};
    state = dotProp.set(state, `current.byClient.${action.clientId}`, client);
  }

  var adjustment = {
    value: action.value,
    description: action.description,
  };
  
  if (!action.value && !action.description)
    state = dotProp.delete(state, `current.byClient.${action.clientId}.adjustment`);
  else
    state = dotProp.set(state, `current.byClient.${action.clientId}.adjustment`, adjustment);

  if (Object.keys(state.current.byClient[action.clientId]).length === 0)
    state = dotProp.delete(state, `current.byClient.${action.clientId}`);

  return state;
}

// Processes ORDER_CLOSE
function closeOrder (state, action) {
  if (Object.keys(state.current.byClient).length === 0)
    return state;

  for (var clientId in state.current.byClient) {
    var clientState = state.current.byClient[clientId];
    for (var productId in clientState) {
      var prodState = clientState[productId];
      var prod = action.products.byId[productId];
      if (prod) {
        if (prodState.unitId >= prod.price.length)
          prodState.unitId = prod.price.length - 1;
        var price = prodState.customPrice ? prodState.customPrice : prod.price[prodState.unitId].price * prodState.quantity;
        state = dotProp.set(state, `current.byClient.${clientId}.${productId}.price`, price);
      }
    }
  }

  state = dotProp.set(state, `current.dateClosed`, new Date().toDateString());
  state = dotProp.set(state, `archive.${state.archive.length}`, state.current);
  state = dotProp.set(state, `current`, { byClient: {}, dateClosed: null })
  return state;
}

// Processes ORDER_REOPEN
function reopenOrder (state, action) {
  if (state.archive.length === 0)
    return state;

  state = dotProp.set(state, `current`, state.archive[state.archive.length-1]);
  state = dotProp.delete(state, `archive.$end`);

  for (var clientId in state.current.byClient) {
    var clientState = state.current.byClient[clientId];
    for (var productId in clientState)
      state = dotProp.delete(state, `current.byClient.${clientId}.${productId}.price`);
  }
  state = dotProp.set(state, `current.dateClosed`, null);
  return state;
}


/****************************************************************
 * Reducers
 ****************************************************************/
// Order Reducer
export function orderReducer (state = orderState, action) {
  switch (action.type) {
    case ClientAction.CLIENT_REMOVE:
      return removeClient(state, action);
    case ProductAction.PRODUCT_REMOVE:
      return removeProduct(state, action);
    case ProductAction.UNIT_REMOVE:
      return removeUnit(state, action);
    case Action.ORDER_SET_PRODUCT:
      return setOrderProduct(state, action);
    case Action.ORDER_SET_ADJUSTMENT:
      return setOrderAdjustment(state, action);
    case Action.ORDER_CLOSE:
      return closeOrder(state, action);
    case Action.ORDER_REOPEN:
      return reopenOrder(state, action);
    default:
      return state;
  }
}

/****************************************************************
 * Exports
 ****************************************************************/
export default orderReducer;



// WEBPACK FOOTER //
// ./src/reducers/order.js